<ng-template #emptyplaces>
    <div class="noplaces">
        <ion-card uppDataid="user-noplaces-warning" [class.ptf-noplaces]="!CanAddPlace" (click)="AddPlace()">
            <ion-icon name="cog-outline"></ion-icon>
            <ion-card-header>
                <ion-card-title>{{tr('@main_no_places_title')}}</ion-card-title>
            </ion-card-header>
          
            <ion-card-content>
                {{tr(CanAddPlace ? '@main_add_place' : '@main_no_places_message')}}
            </ion-card-content>
        </ion-card>    
    </div>
</ng-template>

<ng-template #placesgrid>
    <upp-scrollable>
        <div style="clear: both; height: 10px"></div>
        <upp-grid size="LARGE" name="USER_PLACES_GRID" *ngIf="user">
            <upp-grid-item *ngFor="let _place of user.places; trackBy: PlaceTrack" (click)="SetPlace(_place)">
                <upp-place-thumb [place]="_place"></upp-place-thumb>
            </upp-grid-item>
            <upp-grid-item *ngIf="CanAddPlace" uppDataid="user-add-place" (click)="AddPlace()">
                <upp-thumb icon="add-outline" [title]="tr('@main_add_place')"></upp-thumb>
            </upp-grid-item>
        </upp-grid>        
    </upp-scrollable>
</ng-template>

<ng-container *ngIf="user">
    <ng-container *ngIf="user.places.length === 0">
        <ng-container [ngTemplateOutlet]="emptyplaces"></ng-container>  
    </ng-container>
    <ng-container *ngIf="user.places.length !== 0">
        <ng-container [ngTemplateOutlet]="placesgrid"></ng-container>  
    </ng-container>
</ng-container>
